<template>
  <div class="z-card border-0">
    <div class="z-card__body">
      <column-chart type="BarChart" :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { blue, purple } from '@shared/helpers/css';
  import ColumnChart from '@shared/components/stats-chart-column';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: { ColumnChart },
    computed: {
      ...mapGetters('phone-number/stats/general', { items: DATA }),
      ...mapGetters('phone-number/stats/general', ['filter']),
      ...mapGetters('core/auth', ['user']),
      chart_options() {
        const chartOptions = {
          chartArea: { width: '70%' },
          series: [{ color: blue }, { color: purple }],
          hAxis: {
            title: this.user.currency,
            minValue: 0
          },
          vAxis: {
            title: this.$t(`phone-number.stats.general.field.${this.filter.group_by}`)
          },
          isStacked: false
        };

        return chartOptions;
      },
      chart_data() {
        const headers = [
          this.filter.group_by,
          this.$t('phone-number.stats.general.field.subscription_fee_sum'),
          this.$t('phone-number.stats.general.field.connection_cost_sum')
        ];
        const values = this.items
          .filter((i) => i.group_by !== 'total')
          .map((i) => [i.group_by, i.subscription_fee_sum, i.connection_cost_sum]);
        return [headers, ...values];
      }
    }
  };
</script>
